export default [
    {
		path: '/campaign/:id',
		name: 'Campaign View',
		component: () => import('@/views/campaign/CampaignView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['view', 'campaigns'], ['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/:id/tag/',
		name: 'Campaign Tags View',
		component: () => import('@/views/campaign/CampaignTagsView.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/:id/tag/add',
		name: 'Campaign Tags Add',
		component: () => import('@/views/campaign/CampaignTagsAddForm.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/create',
		name: 'Campaign Create',
		component: () => import('@/views/campaign/CampaignCreate.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/create/details',
		name: 'Campaign Create Details',
		component: () => import('@/views/campaign/CampaignCreateSocial.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/create/reactions',
		name: 'Campaign Create Reactions',
		component: () => import('@/views/campaign/CampaignCreateReactions.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign',
		name: 'Campaign',
		component: () => import('@/views/campaign/Campaign.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/select/member',
		name: 'Campaign Select Members',
		component: () => import('@/views/campaign/CampaignCreateMemberSelect.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	},
	{
		path: '/campaign/select/content',
		name: 'Campaign Select Content',
		component: () => import('@/views/campaign/CampaignCreateContentSelect.vue'),
		meta: {
			layout: 'Default',
			abilities: [['manage', 'campaigns']],
			nav: 'campaign',
		}
	}
]